import ImageCopySectionContainer from './Container'
import { ContentFulPageProps } from './types'

export default function ImageCopySection(props: ContentFulPageProps) {
  return <ImageCopySectionContainer {...props} />
}
